import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Select } from "antd";

const { Option } = Select;

class FormFive extends React.Component {
  render() {
    const { onSubmit, form, signersGroupsGetData } = this.props;
    const { getFieldDecorator } = form;

    const hotelOptions = signersGroupsGetData.users.map((d) => (
      <Option key={d._id} disabled={d.email ? false : true}>
        {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
      </Option>
    ));

    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        onSubmit={onSubmit}
      >
        <Form.Item label="User(s)">
          {getFieldDecorator("signature_cc_recepients_users", {
            initialValue:
              signersGroupsGetData &&
              signersGroupsGetData.signature_cc_recepients
                ? signersGroupsGetData.signature_cc_recepients
                : "",
          })(
            <Select
              mode="multiple"
              showSearch
              placeholder="Select User(s)"
              optionFilterProp="children"
              notFoundContent={null}
            >
              {hotelOptions}
            </Select>
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_five" })(FormFive);

export default WrappedApp;
